import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {LocalstorageService} from 'src/core/data/localstorage.service';
import {ApiService} from 'src/core/http/api.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppLoaderService {
  constructor(private apiService: ApiService, private localStorageService: LocalstorageService) { }

  private jwtHelper = new JwtHelperService();

  censor(censor) {
    var i = 0;

    return function (key, value) {
      if (i !== 0 && typeof (censor) === 'object' && typeof (value) == 'object' && censor == value)
        return '[Circular]';

      if (i >= 29) // seems to be a harded maximum of 30 serialized objects?
        return '[Unknown]';

      ++i; // so we know we aren't using the original object anymore

      return value;
    }
  }

  grayLogger(...args) {
    let vendor: any = localStorage.getItem('vendor');
    if (vendor) {
      vendor = JSON.parse(vendor);
    }

    let token = localStorage.getItem('accessToken');
    let role = undefined;
    let userId = undefined;
    if (token) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      role = decodedToken.role ?? undefined;
      userId = decodedToken.userId ?? undefined;
    }

    const payload = {
      message: JSON.stringify(args, this.censor(args), 2),
      level: 6,
      from: 'SatcomDevDashboard',
      operatorId: vendor.operatorId ?? undefined,
      loginType: vendor.loginType ?? undefined,
      role: role ?? undefined,
      userId: userId ?? undefined,
    }
    var xhr = new XMLHttpRequest();
    xhr.open("POST", this.apiService.baseUrl + 'graylogs', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhr.timeout = 200;
    xhr.send(JSON.stringify(payload));
    console.log("graylogs", payload);
  }

  init() {
    console.log('APP INIT');
    console.log('Production? : ', environment.production);
    if (environment.production) {
      window.console.error = this.grayLogger.bind(this);
      return this.apiService.getBaseUrl();
    } else {
      this.localStorageService.captivePortalBaseUrl = 'https://portal.satcom-dev.grtech.io/';
      this.localStorageService.packagePriceLimit = 20000;
    }
  }

}
